import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את התחושה",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לתחושת הכישלון.",
      "רק לזהות.",
      "אני כאן."
    ],
      [
      "היום אני שם/ה לב לתחושת הכישלון.",
      "רק לזהות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי התחושה הזו עולה במיוחד?",
      "מה אני אומר/ת לעצמי אז?",
      "איפה זה יושב בגוף?"
    ],
      [
      "מתי התחושה הזו עולה במיוחד?",
      "מה אני אומר/ת לעצמי אז?",
      "איפה זה יושב בגוף?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תחושה היא תחושה, לא זהות."
    ],
      [
      "תחושה היא תחושה, לא זהות."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני כאן\".",
      "נשימה אחת + \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע שמפעיל",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שבו התחושה נדלקת.",
      "רק לראות.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני שם/ה לב לרגע שבו התחושה נדלקת.",
      "רק לראות.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קרה ממש לפני שזה התחיל?",
      "איזה משפט על עצמי קופץ מיד?",
      "מה אני מרגיש/ה אז?"
    ],
      [
      "מה קרה ממש לפני שזה התחיל?",
      "איזה משפט על עצמי קופץ מיד?",
      "מה אני מרגיש/ה אז?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מרווח קטן."
    ],
      [
      "ברגע הראשון יש לי מרווח קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשהתחושה עולה.",
      "נשימה אחת כשהתחושה עולה."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הגוף שלי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף כשהכישלון מורגש.",
      "בלי לתקן.",
      "אני כאן."
    ],
      [
      "היום אני מקשיב/ה לגוף כשהכישלון מורגש.",
      "בלי לתקן.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הגוף מחזיק את התחושה?",
      "מה הגוף בוחר/ת ברגע הזה?",
      "מה יכול להתרכך מעט?"
    ],
      [
      "איפה הגוף מחזיק את התחושה?",
      "מה הגוף בוחר/ת ברגע הזה?",
      "מה יכול להתרכך מעט?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עליי."
    ],
      [
      "הגוף מנסה לשמור עליי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "עובדה מול סיפור",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין עובדה לסיפור עליי.",
      "בלי להילחם.",
      "אני כאן."
    ],
      [
      "היום אני מפריד/ה בין עובדה לסיפור עליי.",
      "בלי להילחם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קופץ לי עליי?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ],
      [
      "מה העובדה הפשוטה כאן?",
      "איזה סיפור קופץ לי עליי?",
      "איזו אפשרות עדינה יכולה גם להיות נכונה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא אני."
    ],
      [
      "סיפור הוא לא אני."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זו פרשנות\".",
      "משפט פנימי - \"זו פרשנות\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "המחיר",
    opening: localizedGenderNode(
      [
      "היום אני רואה את המחיר של תחושת הכישלון.",
      "בלי להעניש.",
      "אני כאן."
    ],
      [
      "היום אני רואה את המחיר של תחושת הכישלון.",
      "בלי להעניש.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת מעט את הכתפיים.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה זה לוקח ממני?",
      "איפה אני מצטמצם/ת?",
      "מה הייתי רוצה להחזיר לעצמי?"
    ],
      [
      "מה זה לוקח ממני?",
      "איפה אני מצטמצם/ת?",
      "מה הייתי רוצה להחזיר לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לראות את המחיר זה צעד של חמלה."
    ],
      [
      "לראות את המחיר זה צעד של חמלה."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת על מה שאני מחזיר/ה.",
      "מילה אחת על מה שאני מחזיר/ה."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "טריגרים",
    opening: localizedGenderNode(
      [
      "היום אני מזהה מה מפעיל את תחושת הכישלון.",
      "רק לזהות.",
      "אני כאן."
    ],
      [
      "היום אני מזהה מה מפעיל את תחושת הכישלון.",
      "רק לזהות.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי זה נדלק הכי חזק?",
      "איזה מצב או אדם מפעיל אותי?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ],
      [
      "מתי זה נדלק הכי חזק?",
      "איזה מצב או אדם מפעיל אותי?",
      "מה אני בוחר/ת/ה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "כשאני מזהה טריגר, יש לי מרווח קטן."
    ],
      [
      "כשאני מזהה טריגר, יש לי מרווח קטן."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה כשזה עולה.",
      "יד על החזה כשזה עולה."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "גבול עדין",
    opening: localizedGenderNode(
      [
      "היום אני מציב/ה גבול עדין לקול הכישלון.",
      "בשקט.",
      "אני כאן."
    ],
      [
      "היום אני מציב/ה גבול עדין לקול הכישלון.",
      "בשקט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הגב נתמך.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה משפטים הם יותר מדי בשבילי?",
      "מה הגבול שאני רוצה להציב?",
      "איך אני אומר/ת אותו לעצמי?"
    ],
      [
      "איזה משפטים הם יותר מדי בשבילי?",
      "מה הגבול שאני רוצה להציב?",
      "איך אני אומר/ת אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול פנימי הוא הגנה, לא מלחמה."
    ],
      [
      "גבול פנימי הוא הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לומר \"אני לא מדבר/ת כך אליי\".",
      "לומר \"אני לא מדבר/ת כך אליי\"."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "חמלה קטנה",
    opening: localizedGenderNode(
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "גם אם זה חדש.",
      "אני כאן."
    ],
      [
      "היום אני מנסה לדבר אליי ברוך.",
      "גם אם זה חדש.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ],
      [
      "אני מרכך/ת את הלסת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ],
      [
      "איך הייתי מדבר/ת לחבר/ה כאן?",
      "איזה משפט רך אני בוחר/ת/ה לשמוע?",
      "מה משתנה בי כשאני שומע/ת אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מילה רכה אחת מספיקה להתחלה."
    ],
      [
      "מילה רכה אחת מספיקה להתחלה."
    ]
    ),
    action: localizedGenderNode(
      "משפט רך אחד לעצמי.",
      "משפט רך אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "לראות את הטוב",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת מקום לטוב קטן בי.",
      "בלי להגזים.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת מקום לטוב קטן בי.",
      "בלי להגזים.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שומע/ת את הנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה דבר אחד שטוב בי היום?",
      "איפה זה מורגש בגוף?",
      "מה אני לוקח/ת מזה איתי?"
    ],
      [
      "מה דבר אחד שטוב בי היום?",
      "איפה זה מורגש בגוף?",
      "מה אני לוקח/ת מזה איתי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "טוב קטן מספיק להתחלה."
    ],
      [
      "טוב קטן מספיק להתחלה."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של טוב.",
      "לכתוב מילה אחת של טוב."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה לעצמי",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נותן/ת לעצמי בקשה אחת ברורה.",
      "לא דרישה.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ],
      [
      "מה הבקשה הכי חשובה לי עכשיו?",
      "איך אני אומר/ת אותה במשפט אחד?",
      "מה אני מוכן/ה לתת לעצמי בתמורה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה לרכך את היום."
    ],
      [
      "בקשה אחת יכולה לרכך את היום."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט קצר.",
      "לכתוב את הבקשה במשפט קצר."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "שינוי קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת שינוי קטן בלב היום.",
      "לא מהפכה.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנקודת מגע אחת בגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ],
      [
      "מה שינוי קטן שאני מוכן/ה לנסות היום?",
      "מתי הכי קל לי לנסות אותו?",
      "מה יזכיר לי בעדינות לבחור בו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "שינוי קטן הוא תנועה עדינה."
    ],
      [
      "שינוי קטן הוא תנועה עדינה."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לנסות.",
      "לבחור רגע אחד לנסות."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להיות אנושי/ת",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת מקום ללהיות אנושי/ת.",
      "בלי לבטל.",
      "אני כאן."
    ],
      [
      "היום אני נותן/ת מקום ללהיות אנושי/ת.",
      "בלי לבטל.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה היה קורה אם הייתי מרשה לעצמי להיות אנושי/ת?",
      "מה זה היה משחרר בי?",
      "איזו עדינות אני יכול/ה לתת לעצמי?"
    ],
      [
      "מה היה קורה אם הייתי מרשה לעצמי להיות אנושי/ת?",
      "מה זה היה משחרר בי?",
      "איזו עדינות אני יכול/ה לתת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות אנושי/ת זה לא כישלון."
    ],
      [
      "להיות אנושי/ת זה לא כישלון."
    ]
    ),
    action: localizedGenderNode(
      "משפט אחד של רשות לעצמי.",
      "משפט אחד של רשות לעצמי."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "תרגול קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת תרגול קטן שמרכך את התחושה.",
      "פשוט.",
      "אני כאן."
    ],
      [
      "היום אני בוחר/ת תרגול קטן שמרכך את התחושה.",
      "פשוט.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את הישיבה שלי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תרגול קטן יכול לעזור לי היום?",
      "מתי ביום אני עושה אותו?",
      "מה יזכיר לי בעדינות?"
    ],
      [
      "איזה תרגול קטן יכול לעזור לי היום?",
      "מתי ביום אני עושה אותו?",
      "מה יזכיר לי בעדינות?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "תרגול קטן יוצר שינוי עדין."
    ],
      [
      "תרגול קטן יוצר שינוי עדין."
    ]
    ),
    action: localizedGenderNode(
      "לבחור רגע אחד לתרגול.",
      "לבחור רגע אחד לתרגול."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ],
      [
      "היום אני מסיים/ת את המסע ברוך.",
      "בלי לכפות סיום מושלם.",
      "אני כאן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על תחושת הכישלון?",
      "מה הסימן המוקדם שהיא חוזרת?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ],
      [
      "מה למדתי על תחושת הכישלון?",
      "מה הסימן המוקדם שהיא חוזרת?",
      "משפט חזרה לרגע לפני - מה אני אומר/ת לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה לטעות ולהישאר איתי."
    ],
      [
      "אני יכול/ה לטעות ולהישאר איתי."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני תגובה.",
      "נשימה אחת לפני תגובה."
    ),
  },
].map(buildNormalizedDay);

export const chronicFeelingOfFailureBlueprintHe = buildNormalizedPilotBlueprint({
  id: "chronic_feeling_of_failure_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "chronic_feeling_of_failure",
  category: "self_worth",
  journeyName: {
    he: "תחושת כישלון כרונית",
    en: "Chronic feeling of failure",
    es: "Sensación crónica de fracaso",
  },
  days,
});

export default chronicFeelingOfFailureBlueprintHe;
